import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    QueryList,
    ViewChild,
    ViewChildren,
    ViewEncapsulation
} from '@angular/core';
import { TabItem } from './tab-item.interface';
import { Sine, gsap } from 'gsap';
import { TabChangeEvent } from './tab-change.event';
import { Subject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'ihd-tabs',
    templateUrl: 'tabs.component.html',
    styleUrls: ['./tabs.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'c-tabs'
    }
})
export class TabsComponent implements OnInit, AfterViewInit, OnDestroy {

    @Input()
    set items(items: TabItem[]) {
        this._items = items || [];
        this.currentActiveIndex = null;
        this._items = this._items.map((tabItem: TabItem, index: number) => {

            if (tabItem.active) {
                this.currentActiveIndex = index
            }

            return {
                ...tabItem,
                label: this.translateService.instant(tabItem.label)
            }
        });
    }

    get items() {
        return this._items;
    }

    @Output()
    tabChange: EventEmitter<TabChangeEvent> = new EventEmitter<TabChangeEvent>();

    @ViewChildren('tabItem')
    tabItemsQuery: QueryList<any>;

    @ViewChild('slider')
    slider: ElementRef;

    private currentActiveIndex: number;
    private _items: TabItem[];
    private destroyed$: Subject<void> = new Subject();

    constructor(private translateService: TranslateService) {
    }

    ngOnInit() {
    }

    ngAfterViewInit() {
        this.tabItemsQuery.changes
          .pipe(
            takeUntil(this.destroyed$)
          )
          .subscribe(() => {
              if (this.items && this.items.length) {
                  setTimeout(() => {
                      this.highlightActive();
                  });

              } else {
                  this.positionSlider();
              }
          });

        // this is required for the first time
        if (this.items && this.items.length) {
            this.highlightActive();
        }
    }

    ngOnDestroy() {
        this.destroyed$.next();
    }

    itemClicked(item: TabItem, index: number, event: Event) {
        if (!item.active) {
            if (this.currentActiveIndex >= 0) {
                this.items[this.currentActiveIndex].active = false;
            }

            this.items[index].active = true;

            this.tabChange.emit({
                index,
                item
            });

            this.currentActiveIndex = index;
            this.positionSlider(event.currentTarget);
        }
    }

    private highlightActive() {
        if (this.tabItemsQuery) {
            const activeItem: any = this.tabItemsQuery.find((item: any, index: number, list: any[]) => {
                return index === this.currentActiveIndex
            });

            this.positionSlider(activeItem && activeItem.nativeElement);
        }
    }

    private positionSlider(element?: any) {
        if (element) {
            gsap.to(this.slider.nativeElement, 0.3, {
                x: element.offsetLeft,
                width: element.offsetWidth,
                ease: Sine.easeOut
            });
        } else {
            // remove any highlighted one
            gsap.to(this.slider.nativeElement, 0.3, {
                x: 0,
                width: 0,
                ease: Sine.easeOut
            });
        }

    }
}
